import React, { useState } from "react";
import bigInt from "big-integer";
import Spinner from "./Spinner";

import { useVesting } from "../hooks/useVesting";
import { usePools } from "../hooks/usePools";

import { useHistory } from "react-router-dom";

import { withRouter } from "react-router-dom";
import { withNamespaces } from "react-i18next";

import { toFixed } from "../../../constants/constants";

import { withStyles } from "@material-ui/core/styles";
import Button from "./Button";
import UnstakeModal from "./UnstakeModal";
import ConfirmationModal from "../../confirmationModal";
import VestingMobileCard from "./VestingMobileCard";
import ConnectWalletButton from "../../connectWalletButton";
import { useAccount } from "../../../contexts/AccountContext";
import { BUIDL_USDC_POOL_ADDRESS } from "../constants/constants";

const styles = (theme) => ({
  root: {
    flex: 1,
    display: "flex",
    width: "100%",
    justifyContent: "center",
    alignItems: "flex-start",
    flexDirection: "column",
    padding: "30px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "row",
      padding: "70px",
    },
    position: "relative",
  },
  goBackContainer: {
    display: "flex",
    alignItems: "center",
    marginRight: "auto",

    marginBottom: "8px",
    [theme.breakpoints.up("sm")]: {
      marginBottom: "16px",
    },
  },
  goBackIcon: {
    stroke: theme?.colors?.presale?.cardTitle,
    width: "24px",
    height: "24px",
    cursor: "pointer",
  },
  goBackBtn: {
    color: theme?.colors?.presale?.cardTitle,
    backgroundColor: "transparent",
    border: "none",
    fontWeight: "600",
    fontSize: "18px",
    cursor: "pointer",

    [theme.breakpoints.up("sm")]: {
      fontSize: "22px",
    },
  },
  vestingBoardContainer: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
    maxWidth: "1140px",
  },
  vestingBoardHeading: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "32px",

    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    [theme.breakpoints.down("675px")]: {
      fontSize: "22px",

      marginBottom: "10px",
    },
  },
  vestingBoardSubHeading: {
    textAlign: "left",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    [theme.breakpoints.down("675px")]: {
      fontSize: "14px",
    },
  },
  vestingBoardSubBold: {
    color: theme?.colors?.presale?.cardTitle,
  },
  vestingBoardLoader: {
    width: "100%",
    display: "flex",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "62px",
  },
  vestingBoardList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  vestingBoardTable: {
    width: "100%",
    marginTop: "1.5rem",
    borderCollapse: "collapse",
    borderSpacing: "0",
    boxShadow: "0px 10px 60px " + theme?.colors?.containerShadow,
    borderRadius: "32px",

    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "table",
    },
  },
  vestingBoardTableHeader: {
    height: "50px",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
  },
  vestingBoardTableTh: {
    width: "15%",
    padding: "16px",
    fontWeight: "normal",
    textAlign: "left",
  },
  vestingBoardTableRow: {
    height: "100px",
    borderBottom: "solid 2px " + theme?.colors?.presale?.cardTitle,
    "&:last-child": {
      borderBottom: "none",
    },
  },
  vestingBoardButtonsContainer: {
    width: "100%",
    display: "flex",
    gap: "16px",
    padding: "16px",
    alignItems: "center",
    justifyContent: "space-around",
  },

  tableHeader: {
    color: "#A0A0A0",
    fontSize: "14px",
    // background: "#393939",
    background: theme?.colors?.pools?.headerBackground,
    borderBottom: "1px solid " + theme?.colors?.pools?.rowBorderBottom,
    padding: "16px",
  },
  tableBody: {
    background: theme?.colors?.pools?.bodyBackground,
    color: "#fff",
    width: "100%",
  },

  tableRow: {
    borderBottom: "1px solid" + theme?.colors?.pools?.rowBorderBottom,
    color: theme?.colors?.pools?.tableDataText,
  },
  tableRowLast: {
    borderBottom: "none",
    color: theme?.colors?.pools?.tableDataText,
  },
  vestingBoardTableTd: {
    padding: "16px",
    color: theme?.colors?.pools?.tableDataText,
  },
  vestingBoardTableImgSymbol: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  vestingBoardTableTdImg: {
    width: "45px",
    marginRight: "10px",
    objectFit: "contain",
  },
  vestingBoardTableTdText: {},
  vestingBoardTime: {
    mixBlendMode: "normal",
  },
  connectContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  connectText: {
    textAlign: "center",
    fontFamily: "Poppins",
    fontSize: "18px",
    fontWeight: "600",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    marginBottom: "10px",
  },
  connectButton: {
    width: "200px",
  },
  vestingBoardTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "30px",
    [theme.breakpoints.down("675px")]: {
      flexDirection: "column",
    },
  },
  vestingBoardTitleLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    [theme.breakpoints.down("675px")]: {
      alignItems: "center",
    },
  },
  vestingBoardTitleRight: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    [theme.breakpoints.down("675px")]: {
      alignItems: "center",
    },
  },
  vestingBoardAddress: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "10px",
    marginRight: "50px",
    border: "solid 2px #A0A0A0",
    borderRadius: "20px",
    fontFamily: "Poppins",
    fontSize: "18px",
    letterSpacing: "0px",
    color: "#A0A0A0",
    cursor: "pointer",
    [theme.breakpoints.down("675px")]: {
      marginRight: "0px",
    },
    "&:hover": {
      border: "solid 2px " + theme?.colors?.presale?.cardTitle,
      color: theme?.colors?.presale?.cardTitle,
    },
  },

  stakingIncomeMobile: {
    width: "100%",
    marginTop: "1.5rem",
    gap: "26px",
    flexDirection: "column",

    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
});

const VestingBoard = ({ classes }) => {
  const history = useHistory();
  const { items: pools, isLoading: isPoolsLoading } = usePools();
  const {
    vestings,
    unstake,
    isLoading,
    burnFee,
    lastInvestTimestamp,
    lastUnstakedTime,
  } = useVesting();

  const [showUnstakeModal, setShowUnstakeModal] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const [selectedVestingToUnstake, setSelectedVestingToUnstake] = useState({});

  const { account } = useAccount();

  const onWithdraw = async (poolAddress, depositId, amount) => {
    setShowLoadingModal(true);
    try {
      await unstake(
        pools[poolAddress],
        depositId,
        bigInt(amount).subtract(1).toString()
      );

      setShowSuccessModal(true);
    } catch (error) {
      console.error("UNSTAKE ERROR", error);
      setShowLoadingModal(false);
      setShowSuccessModal(false);
    }
  };

  const getUnlocksTime = (timestamp) => {
    const currentTimestamp = parseInt(Date.now() / 1000);
    if (timestamp === 0 || timestamp < currentTimestamp) {
      return "Unlocked";
    }
    const period = timestamp - currentTimestamp;

    if (period < 60) {
      return `Unlocks in ${period} seconds`;
    }
    if (period < 3600) {
      return `Unlocks in ${parseInt(period / 60)} minutes`;
    }
    if (period < 3600 * 24) {
      return `Unlocks in ${parseInt(period / 3600)} hours`;
    }
    if (period < 86400 * 30) {
      return `Unlocks in ${parseInt(period / 86400)} days`;
    }
    return `Unlocks in ${parseInt(period / 2592000)} months`;
  };

  const isUnlocked = (timestamp) => {
    const currentTimestamp = parseInt(Date.now() / 1000);
    if (timestamp === 0 || timestamp < currentTimestamp) {
      return true;
    }
    return false;
  };

  const onUnstake = (poolAddress, vesting) => {
    setSelectedVestingToUnstake({
      poolAddress,

      depositId: vesting?.depositId,
      tokenAmount: vesting?.tokenAmount,
    });
    setShowUnstakeModal(true);
  };

  return (
    <div className={classes.vestingBoardContainer}>
      <div className={classes.goBackContainer}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          className={classes.goBackIcon}
          onClick={() => {
            history.goBack();
          }}
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M15.75 19.5 8.25 12l7.5-7.5"
          />
        </svg>

        <button
          className={classes.goBackBtn}
          type="button"
          onClick={() => {
            history.goBack();
          }}
        >
          Go back
        </button>
      </div>
      <div className={classes.vestingBoardTitleContainer}>
        <div className={classes.vestingBoardTitleLeft}>
          <h1 className={classes.vestingBoardHeading}>VESTING</h1>
          <span className={classes.vestingBoardSubHeading}>
            Vested rewards and unlocked deposits can be withdrawn{" "}
            <span className={classes.vestingBoardSubBold}>at any time</span>.
            Yields that are subject to vesting are tracked separately and
            keeping them deposited compounds your earnings.
          </span>
        </div>
      </div>
      {!account || !account.address ? (
        <div className={classes.connectContainer}>
          <div className={classes.connectText}>
            Connect your wallet to see available pools
          </div>
          <ConnectWalletButton />
        </div>
      ) : isLoading ||
        isPoolsLoading ||
        !vestings ||
        Object.keys(vestings).length === 0 ? (
        <div className={classes.vestingBoardLoader}>
          <Spinner strokeSize="6px" width="54px" height="54px" />
        </div>
      ) : (
        <div className={classes.vestingBoardList}>
          <div>
            <>
              <table className={classes.vestingBoardTable}>
                <thead className={classes.tableHeader}>
                  <tr>
                    <th
                      style={{
                        padding: "16px",
                        borderTopLeftRadius: "32px",
                        fontWeight: "normal",
                        width: "30%",
                      }}
                    >
                      Pools
                    </th>
                    <th
                      className={classes.vestingBoardTableTh}
                      style={{ width: "20%" }}
                    >
                      Amount
                    </th>
                    <th
                      className={classes.vestingBoardTableTh}
                      style={{ width: "20%" }}
                    >
                      Unlocks in
                    </th>
                    <th
                      className={classes.vestingBoardTableTh}
                      style={{ width: "30%" }}
                    >
                      Source
                    </th>
                    <th
                      style={{
                        padding: "16px",
                        borderTopRightRadius: "32px",
                        fontWeight: "normal",
                        width: "30%",
                      }}
                    />
                  </tr>
                </thead>
                <tbody className={classes.tableBody}>
                  {Object.keys(vestings).map((poolAddress) => {
                    const pool = pools[poolAddress];

                    const vestingsWithAmount = vestings[poolAddress].filter(
                      (vesting) => {
                        return bigInt(vesting.tokenAmount).greater("1");
                      }
                    );

                    return vestingsWithAmount.map((vesting, index) => (
                      <tr
                        className={
                          index === vestingsWithAmount.length - 1
                            ? classes.tableRowLast
                            : classes.tableRow
                        }
                        key={`${poolAddress}-${vesting.depositId}`}
                      >
                        <td
                          className={classes.vestingBoardTableTd}
                          style={
                            index === vestingsWithAmount.length - 1
                              ? {
                                  padding: "16px",
                                  borderBottomLeftRadius: "32px",
                                }
                              : { padding: "16px" }
                          }
                        >
                          <div className={classes.vestingBoardTableImgSymbol}>
                            <img
                              src={`/tokens/${pool?.token?.address}.png`}
                              alt="img"
                              className={classes.vestingBoardTableTdImg}
                            />
                            <span className={classes.vestingBoardTableTdText}>
                              {pool?.token?.symbol}
                            </span>
                          </div>
                        </td>
                        <td className={classes.vestingBoardTableTd}>
                          {toFixed(
                            vesting?.tokenAmount,
                            pool?.token?.decimals || 18,
                            2
                          ) || "0"}
                        </td>
                        <td className={classes.vestingBoardTableTd}>
                          <span className={classes.vestingBoardTime}>
                            {getUnlocksTime(parseInt(vesting?.lockedUntil))}
                          </span>
                        </td>
                        <td className={classes.vestingBoardTableTd}>
                          {vesting?.isYield ? "Yield" : "Deposit"}
                        </td>
                        <td
                          style={
                            index === vestingsWithAmount.length - 1
                              ? {
                                  padding: "16px",
                                  borderBottomRightRadius: "32px",
                                }
                              : { padding: "16px" }
                          }
                        >
                          <div className={classes.vestingBoardButtonsContainer}>
                            {showLoadingModal ? (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                onClick={() => {
                                  // TODO: Add wait function
                                }}
                                text="Please Wait..."
                              />
                            ) : isUnlocked(parseInt(vesting?.lockedUntil)) ? (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                disabled={
                                  Number(
                                    toFixed(
                                      vesting?.tokenAmount,
                                      pool?.token?.decimals || 18,
                                      2
                                    )
                                  ) === 0
                                }
                                onClick={() => onUnstake(poolAddress, vesting)}
                                text="Unstake"
                              />
                            ) : (
                              <Button
                                classes={{
                                  root: classes.poolButton,
                                  label: classes.buttonLabel,
                                }}
                                onClick={() => {}}
                                disabled
                                text="Locked"
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ));
                  })}
                </tbody>
              </table>

              <div className={classes.stakingIncomeMobile}>
                {Object.keys(vestings).map((poolAddress, index) => {
                  const pool = pools[poolAddress];
                  return vestings[poolAddress]
                    .filter((vesting) => {
                      return bigInt(vesting.tokenAmount).greater("1");
                    })
                    .map((vesting) => (
                      <VestingMobileCard
                        pool={pool}
                        vesting={vesting}
                        getUnlocksTime={getUnlocksTime}
                        showLoadingModal={showLoadingModal}
                        isUnlocked={isUnlocked(parseInt(vesting?.lockedUntil))}
                        poolAddress={poolAddress}
                        onUnstake={onUnstake}
                      />
                    ));
                })}
              </div>
            </>
          </div>
        </div>
      )}

      {/* todo: OpenModal */}
      {/* <WalletModal
        modalOpen={walletModal}
        onClose={() => {
          showWalletModal(false);
        }}
      /> */}

      <UnstakeModal
        closeModal={() => {
          setShowUnstakeModal(false);
        }}
        modalOpen={showUnstakeModal}
        unstakeMsg={
          selectedVestingToUnstake?.poolAddress !== BUIDL_USDC_POOL_ADDRESS
            ? "Please be aware that you will lose potential staking rewards by unstaking. Are you sure you would like to continue?"
            : undefined
        }
        burnFee={burnFee}
        lastInvestTimestamp={lastInvestTimestamp}
        lastUnstakedTime={lastUnstakedTime}
        onUnstake={() => {
          onWithdraw(
            selectedVestingToUnstake?.poolAddress,
            selectedVestingToUnstake?.depositId,
            selectedVestingToUnstake?.tokenAmount
          );
        }}
      />

      <ConfirmationModal
        modalOpen={showLoadingModal}
        onClose={() => {
          setShowLoadingModal(false);
          setShowSuccessModal(false);
        }}
        showSuccessModal={showSuccessModal}
      />
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(VestingBoard)));
